<wl-simple-progressive-form-card
  [progressiveFormState]="progressiveFormState()"
  [content]="progressiveFormCardContent()"
  [asyncSubmission]="true"
  [trackingConfig]="{
    toolName: rendering().componentName,
    step: stepNumber(),
    stepName: 'persoonlijke gegevens',
  }"
>
  <ng-template #content>
    @if (orderContent().enableBusinessFields) {
      <div>
        <p class="h6">{{ orderContent().businessFieldsTitle }}</p>
      </div>
      <div class="row g-1 mb-2">
        <div class="col-12 col-lg-6">
          <wl-text
            [rendering]="rendering()"
            stepName="persoonlijke gegevens"
            [step]="stepNumber()"
            fieldName="bedrijfsnaam"
            [sendValue]="false"
            [formsControl]="formState().controls.companyName"
            [placeholder]="orderContent().companyNamePlaceholder"
            [label]="orderContent().companyNameLabel"
          ></wl-text>
          @if (formState().controls.companyName | isInvalid) {
            @if (formState().controls.companyName.errors['required']) {
              <wl-input-error
                wlAutomationId="company-name-required-error"
                [messageField]="orderContent().companyNameRequiredError"
                messageDescription="bedrijfsnaam"
                [rendering]="rendering()"
                stepName="persoonlijke gegevens"
                [step]="stepNumber()"
              ></wl-input-error>
            }
          }
        </div>
        <div class="col-12 col-lg-6 mt-2 mt-lg-1">
          <wl-text
            [rendering]="rendering()"
            stepName="persoonlijke gegevens"
            [step]="stepNumber()"
            fieldName="kvk nummer"
            [sendValue]="false"
            [formsControl]="formState().controls.kvkNumber"
            [placeholder]="orderContent().kvkNumberPlaceholder"
            [label]="orderContent().kvkNumberLabel"
          ></wl-text>
          @if (formState().controls.kvkNumber | isInvalid) {
            <wl-input-error
              wlAutomationId="kvk-number-required-error"
              [messageField]="orderContent().kvkNumberRequiredError"
              messageDescription="kvknummer"
              [rendering]="rendering()"
              stepName="persoonlijke gegevens"
              [step]="stepNumber()"
            ></wl-input-error>
          }
        </div>
      </div>
    }
    @if (orderContent().enablePersonalFields) {
      <div>
        <p class="h6">{{ orderContent().salutationLabel }}</p>
      </div>
      <div class="row g-1 mb-2">
        <!-- Salutation -->
        <wl-radio
          class="col-12"
          [rendering]="rendering()"
          [step]="stepNumber()"
          stepName="persoonlijke gegevens"
          fieldName="geslacht"
          wlAutocomplete="suffix"
          [sendValue]="false"
          [formsControl]="formState().controls.gender"
          [radioItems]="genderOptions()"
          [inline]="true"
        ></wl-radio>
        @if (formState().controls.gender | isInvalid) {
          @if (formState().controls.gender.errors['required']) {
            <wl-input-error
              wlAutomationId="gender-required-error"
              [messageField]="orderContent().genderRequiredError"
              messageDescription="geslacht"
              [rendering]="rendering()"
              stepName="persoonlijke gegevens"
              [step]="stepNumber()"
            ></wl-input-error>
          }
        }
      </div>
      <div class="row g-1 mb-2">
        <!-- Initials -->
        <div class="col-6 col-lg-3">
          <wl-text
            [rendering]="rendering()"
            stepName="persoonlijke gegevens"
            [step]="stepNumber()"
            fieldName="voorletter"
            wlAutocomplete="suffix"
            [sendValue]="false"
            [formsControl]="formState().controls.initials"
            [valueConverter]="_initialsConverter"
            [placeholder]="orderContent().initialsPlaceholder"
            [label]="orderContent().initialsLabel"
            [floatingLabel]="!labelsShownAboveFields()"
          />
          @if (formState().controls.initials | isInvalid) {
            <wl-input-error
              wlAutomationId="initials-required-error"
              [messageField]="orderContent().initialsRequiredError"
              messageDescription="voorletter"
              [rendering]="rendering()"
              stepName="persoonlijke gegevens"
              [step]="stepNumber()"
            ></wl-input-error>
          }
        </div>
        <!-- Insertion -->
        <div class="col-6 col-lg-3">
          <wl-text
            [rendering]="rendering()"
            stepName="persoonlijke gegevens"
            [step]="stepNumber()"
            fieldName="tussenvoegsel"
            [sendValue]="false"
            [formsControl]="formState().controls.prefix"
            [placeholder]="orderContent().insertionPlaceholder"
            [label]="orderContent().insertionLabel"
            [floatingLabel]="!labelsShownAboveFields()"
          />
        </div>
        <!-- Surname -->
        <div class="col-12 col-lg-6">
          <wl-text
            [rendering]="rendering()"
            stepName="persoonlijke gegevens"
            [step]="stepNumber()"
            fieldName="achternaam"
            wlAutocomplete="family-name"
            [sendValue]="false"
            [formsControl]="formState().controls.lastName"
            [placeholder]="orderContent().surnamePlaceholder"
            [label]="orderContent().surnameLabel"
            [floatingLabel]="!labelsShownAboveFields()"
          />
          @if (formState().controls.lastName | isInvalid) {
            <wl-input-error
              wlAutomationId="lastname-required-error"
              [messageField]="orderContent().surnameRequiredError"
              messageDescription="achternaam"
              [rendering]="rendering()"
              stepName="persoonlijke gegevens"
            ></wl-input-error>
          }
        </div>
      </div>
      <div class="row g-1 mb-2">
        <!-- Date of birth -->
        <div class="col-12 col-lg-6">
          <wl-date-input
            wlAutocomplete="bday-formatted"
            [rendering]="rendering()"
            stepName="persoonlijke gegevens"
            [step]="stepNumber()"
            fieldName="geboortedatum"
            [sendValue]="false"
            [formsControl]="formState().controls.dateOfBirth"
            [placeholder]="orderContent().birthdatePlaceholder"
            [label]="orderContent().birthdateLabel"
            [labelFloating]="!labelsShownAboveFields()"
          />
          @if (formState().controls.dateOfBirth | isInvalid) {
            <wl-input-error
              wlAutomationId="dateofbirth-required-error"
              [messageField]="orderContent().birthdateRequiredError"
              messageDescription="geboortedatum"
              [rendering]="rendering()"
              stepName="persoonlijke gegevens"
              [step]="stepNumber()"
            ></wl-input-error>
          }
        </div>
      </div>
    }
    @if (orderContent().enableBusinessCheckbox) {
      <div id="business-checkbox" class="row g-1 mb-2">
        <wl-checkbox
          [rendering]="rendering()"
          stepName="persoonlijke gegevens"
          [step]="stepNumber()"
          fieldName="zakelijke klant"
          [formsControl]="formState().controls.businessClient"
          [label]="orderContent().businessClientLabel"
          [tooltip]="orderContent().businessClientTooltip"
          [showValidation]="false"
        >
        </wl-checkbox>
      </div>
    }

    @if (formState().controls.businessClient.value) {
      <wl-info-card
        [type]="'info'"
        [backgroundGrey]="true"
        [title]="{ value: orderContent().businessClientMessageTitle }"
        [message]="orderContent().businessClientMessageBody"
      ></wl-info-card>
    } @else {
      <div class="pt-1">
        <p class="h6">{{ orderContent().contactDetailsLabel }}</p>
      </div>
      <p class="text-body-secondary">{{ orderContent().emailDisclosure }}</p>
      <div class="row g-1 mb-2">
        <!-- email -->
        <div class="col-12 col-lg-6">
          <wl-email
            [rendering]="rendering()"
            [sendValue]="false"
            stepName="persoonlijke gegevens"
            [step]="stepNumber()"
            fieldName="emailadres"
            [formsControl]="formState().controls.email"
            [label]="orderContent().emailLabel"
            [placeholder]="orderContent().emailPlaceholder"
            [tooltip]="orderContent().emailTooltip"
            [floatingLabel]="!labelsShownAboveFields()"
          />
          @if (formState().controls.email | isInvalid) {
            <wl-input-error
              wlAutomationId="email-required-error"
              [messageField]="orderContent().emailRequiredError"
              messageDescription="emailadres"
              [rendering]="rendering()"
              stepName="persoonlijke gegevens"
              [step]="stepNumber()"
            ></wl-input-error>
          }
        </div>
        <!-- emailValidation -->
        <div class="col-12 col-lg-6">
          <wl-email
            [rendering]="rendering()"
            stepName="persoonlijke gegevens"
            [step]="stepNumber()"
            fieldName="email validatie"
            [sendValue]="false"
            [formsControl]="formState().controls.emailValidation"
            [label]="orderContent().emailCheckLabel"
            [placeholder]="orderContent().emailCheckPlaceholder"
            [preventPaste]="true"
            [floatingLabel]="!labelsShownAboveFields()"
            wlAutocompleteDisabled
          />
          @if (
            !emailFieldValuesMatch() &&
            (formState().controls.emailValidation | isInvalid)
          ) {
            <wl-input-error
              wlAutomationId="email-validation-error"
              [messageField]="orderContent().emailValidationError"
              messageDescription="emailadres-valideren"
              [rendering]="rendering()"
              stepName="persoonlijke gegevens"
              [step]="stepNumber()"
            ></wl-input-error>
          }
        </div>
      </div>
      <div class="row g-1 mb-2">
        <!-- phone -->
        <div class="col-12 col-lg-6">
          <wl-phone
            [rendering]="rendering()"
            stepName="persoonlijke gegevens"
            [step]="stepNumber()"
            fieldName="telefoonnummer"
            [sendValue]="false"
            [formsControl]="formState().controls.phone"
            [label]="orderContent().phoneLabel"
            [placeholder]="orderContent().phonePlaceholder"
            [tooltip]="orderContent().phoneTooltip"
            [floatingLabel]="!labelsShownAboveFields()"
          />
          @if (formState().controls.phone | isInvalid) {
            <wl-input-error
              wlAutomationId="phone-required-error"
              [messageField]="orderContent().phoneRequiredError"
              messageDescription="telefoonnummer"
              [rendering]="rendering()"
              stepName="persoonlijke gegevens"
              [step]="stepNumber()"
            ></wl-input-error>
          }
        </div>
      </div>
    }
  </ng-template>
  <ng-template #summary>
    @if (orderContent().enableBusinessFields) {
      <p class="h6 mb-0">{{ orderContent().businessFieldsTitle }}</p>
      <ul class="list-unstyled list-unstyled--no-spacing mb-3" wlCSMask>
        <li>
          {{ formState().value.companyName }}
        </li>
        <li>
          {{ formState().value.kvkNumber }}
        </li>
      </ul>
    }

    @if (orderContent().enablePersonalFields) {
      <p class="h6 mb-0">{{ orderContent().salutationLabel }}</p>
      <ul class="list-unstyled list-unstyled--no-spacing mb-3" wlCSMask>
        <li>
          {{ formState().value.initials }}
        </li>
        <li>
          {{ formState().value.prefix }}
        </li>
        <li>
          {{ formState().value.lastName }}
        </li>
        <li>{{ givenDateOfBirth() | date: 'd MMMM yyyy' }}</li>
      </ul>
    }

    <p class="h6 mb-0">{{ orderContent().contactDetailsLabel }}</p>
    <ul class="list-unstyled list-unstyled--no-spacing mb-3" wlCSMask>
      <li>{{ formState().value.email }}</li>
      <li>{{ formState().value.phone }}</li>
    </ul>
  </ng-template>
</wl-simple-progressive-form-card>
